import OrderPolicy from './OrderPolicy';
import UserPolicy from './UserPolicy';
import TransactionPolicy from './TransactionPolicy';
import WriterPaymentPolicy from './WriterPaymentPolicy';
import WriterProfilePolicy from './WriterProfilePolicy';
import CommentPolicy from './CommentPolicy';
import AffiliatePolicy from './AffiliatePolicy';

export default class User
{

    constructor(user)
    {
        this.user = user;

        if(user) {
            if(user.role === 1){user.role_name = 'customer'}
            if(user.role === 2){user.role_name = 'writer'}
            if(user.role === 3){user.role_name = 'admin'}
            if(user.role === 4){user.role_name = 'editor'}
            if(user.role === 5){user.role_name = 'affiliate'}
            if(user.role === 6){user.role_name = 'support'}
        }


        this.policies = {
            orderPolicy: OrderPolicy,
            user: UserPolicy,
            transactionPolicy: TransactionPolicy,
            writerPaymentPolicy: WriterPaymentPolicy,
            writerProfilePolicy: WriterProfilePolicy,
            commentPolicy: CommentPolicy,
            affiliatePolicy: AffiliatePolicy,
        };
    }



    before()
    {
        return this.user && (this.user.role === 3 || this.user.role === 6);
    }

    can(action, type, model = null, secondModel = null)
    {
        if (this.before()) {
            return true;
        }

        if (!this.user) {
            return false;
        }

        return this.policies[type][action](this.user, model, secondModel);
    }


    isCustomer()
    {
        return this.user && user.role_name === 'customer';
    }

    isWriter()
    {
        return this.user && user.role_name === 'writer' || user.role_name === 'editor';
    }

    isEditor()
    {
        return this.user && user.role_name === 'editor';
    }

    isAdmin()
    {
        return this.user && (user.role_name === 'admin' || user.role_name === 'support');
    }

    isAffiliate()
    {
        return this.user && user.role_name === 'affiliate';
    }
    isSupport()
    {
        return this.user && user.role_name === 'support';
    }

    isTester()
    {
        return this.user && user.test === 1;
    }
    isUnderEditing()
    {
        return this.user && this.user.profile && this.user.profile.under_editing === 1;
    }

    id()
    {
        if(this.user) {
            return user.id;
        }
    }
    avatar()
    {
        if(this.user) {
            return user.avatar;
        }
    }
}
